import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../Header/Header1";
import "./bot.scss";
import { Button, FormLabel } from "@mui/material";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TablePagination,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Loader from "../Loader";
import consts from "../../constant";
import usercalls from "../../Axios";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { io } from "socket.io-client";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "80%",
    sm: 400,
  },
  bgcolor: "var(--common-card-bg)",
  borderRadius: "10px",
  p: 2,
};

const INITIAL_FUNDS_FORM_DATA = {
  type: "add",
  order_type: "market",
  units: "",
  price: "",
};

const initialForm = {
  pair: "",

  leverage_enabled: "false",
  leverage_type: "cross",
  leverage_value: "",

  position_type: "buy",
  position_order_type: "limit",
  position_units: "",
  position_price: "",

  conditional_enabled: "false",
  conditional_order_type: "market",
  conditional_price: "",
  conditional_trailing_enabled: "false",
  conditional_trailing_percent: "",

  take_profit_enabled: "false",
  take_profit_order_type: "market",
  take_profit_price: "",
  take_profit_type: "last",
  take_profit_trailing: "false",
  take_profit_percentage: "",
  take_profit_trailing_enabled: "false",
  take_profit_trailing_percent: "",

  stop_loss_enabled: "false",
  stop_loss_order_type: "market",
  stop_loss_price: "",
  stop_loss_price_type: "last",
  stop_loss_timeout_enabled: "false",
  stop_loss_timeout_seconds: "",
  stop_loss_trailing: "false",
  stoploss_percentage: "",
  stop_loss_trailing_enabled: "false",
  stop_loss_trailing_percent: "",
  stop_loss_breakeven: "false",

  note: "",
};

const SmartTrade = () => {
  const [tradeLoading, setTradeLoading] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const path = usercalls();
  const [openTrade, setOpenTrade] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [smartTrades, setSmartTrades] = useState([]);
  const [smartTradeTotal, setSmartTradeTotal] = useState(0);
  const [pairs, setPairs] = useState([]);
  const [pairSearch, setPairSearch] = useState("");
  const [pairsLoading, setPairsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const paginationRef = useRef({ page: 0, rowsPerPage: 10 });
  const [submitLoading, setSubmitLoading] = useState(false);
  const [openFundsModal, setOpenFundsModal] = useState(false);
  const [selectedTradeId, setSelectedTradeId] = useState(null);
  const [fundsLoading, setFundsLoading] = useState(false);
  const [reduceInfo, setReduceInfo] = useState(null);
  const [fundsFormData, setFundsFormData] = useState(INITIAL_FUNDS_FORM_DATA);
  const [actionLoading, setActionLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState({
    action: null,
    tradeId: null,
    message: null,
  });
  const [currencyRates, setCurrencyRates] = useState({});
  const [openTradesModal, setOpenTradesModal] = useState(false);
  const [selectedSmartTradeId, setSelectedSmartTradeId] = useState(null);
  const [smartTradeTrades, setSmartTradeTrades] = useState([]);
  const [tradesLoading, setTradesLoading] = useState(false);
  const [tradeActionLoading, setTradeActionLoading] = useState(false);
  const [showTradeConfirmModal, setShowTradeConfirmModal] = useState(false);
  const [confirmTradeAction, setConfirmTradeAction] = useState({
    action: null,
    smartTradeId: null,
    tradeId: null,
    message: null,
  });
  const getPairLabel = (pairItem) =>
    typeof pairItem === "string"
      ? pairItem
      : pairItem?.pair || pairItem?.symbol || pairItem?.name || pairItem?.label;
  const getPairValue = (pairItem) =>
    typeof pairItem === "string"
      ? pairItem
      : pairItem?.pair || pairItem?.symbol || pairItem?.name || pairItem?.value;
  const normalizedPairSearch = pairSearch.trim().toLowerCase();
  const filteredPairs = pairs.filter((pairItem) => {
    if (!normalizedPairSearch) return true;
    const label = String(getPairLabel(pairItem) || "").toLowerCase();
    const value = String(getPairValue(pairItem) || "").toLowerCase();
    return (
      label.includes(normalizedPairSearch) ||
      value.includes(normalizedPairSearch)
    );
  });

  const [formData, setFormData] = useState(initialForm);

  paginationRef.current = { page, rowsPerPage };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "pair") {
      const pair = String(value || "")
        .split(",")[0]
        .trim();
      if (pair) {
        getCurrencyRates(pair);
      } else {
        setCurrencyRates({});
      }
      setPairSearch("");
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getCurrencyRates = async (pair) => {
    try {
      const url = `https://api.3commas.io/public/api/ver1/accounts/currency_rates?market_code=kucoin&pair=${pair}`;
      const { data } = await axios.get(url);
      if (data) {
        setCurrencyRates(data);
      } else {
        setCurrencyRates({});
      }
    } catch (err) {
      setCurrencyRates({});
    }
  };

  const getPairs = async () => {
    try {
      setPairsLoading(true);
      const url = `${consts.BackendUrl}/bots/get-trading-pairs`;
      const payload = {
        market: state?.market_code || state?.market,
      };
      const response = await path.postCall({ url, payload });
      const result = await response.json();
      if (result?.success || Array.isArray(result)) {
        setPairs(Array.isArray(result) ? result : result?.result || []);
      } else {
        setPairs([]);
      }
      setPairsLoading(false);
    } catch (err) {
      setPairs([]);
      setPairsLoading(false);
    }
  };

  const validateForm = () => {
    const isEnabled = (value) => value === true || value === "true";
    const isBlank = (value) =>
      value === undefined || value === null || String(value).trim() === "";
    const toNumber = (value) => Number(value);
    const isPositiveNumber = (value) => {
      const num = toNumber(value);
      return !Number.isNaN(num) && num > 0;
    };
    const isIntegerAtLeastOne = (value) => {
      const num = toNumber(value);
      return !Number.isNaN(num) && Number.isInteger(num) && num >= 1;
    };
    const isPercentageRange = (value) => {
      const num = toNumber(value);
      return !Number.isNaN(num) && num >= 0.01 && num <= 100;
    };

    const isConditionalEnabled = isEnabled(formData.conditional_enabled);
    const isTakeProfitEnabled = isEnabled(formData.take_profit_enabled);
    const isTakeProfitTrailingEnabled = isEnabled(
      formData.take_profit_trailing,
    );
    const isStopLossEnabled = isEnabled(formData.stop_loss_enabled);
    const isStopLossTimeoutEnabled = isEnabled(
      formData.stop_loss_timeout_enabled,
    );
    const isStopLossTrailingEnabled = isEnabled(formData.stop_loss_trailing);
    const currentMarketPrice = Number(currencyRates?.last);
    const hasCurrentMarketPrice =
      Number.isFinite(currentMarketPrice) && currentMarketPrice > 0;

    if (isBlank(formData.pair)) {
      toast.error("Trading pair is required.");
      return false;
    }

    if (!["buy", "sell"].includes(formData.position_type)) {
      toast.error("Position side must be Buy or Sell.");
      return false;
    }

    if (
      !["market", "limit", "conditional"].includes(formData.position_order_type)
    ) {
      toast.error("Position order type must be Market, Limit, or Conditional.");
      return false;
    }

    if (
      isBlank(formData.position_units) ||
      !isPositiveNumber(formData.position_units)
    ) {
      toast.error("Position units must be greater than 0.");
      return false;
    }

    if (
      formData.position_order_type === "limit" &&
      (isBlank(formData.position_price) ||
        !isPositiveNumber(formData.position_price))
    ) {
      toast.error("Position price must be greater than 0 for Limit orders.");
      return false;
    }

    if (isConditionalEnabled) {
      if (!["market", "limit"].includes(formData.conditional_order_type)) {
        toast.error("Conditional order type must be Market or Limit.");
        return false;
      }

      if (
        isBlank(formData.conditional_price) ||
        !isPositiveNumber(formData.conditional_price)
      ) {
        toast.error("Conditional price must be greater than 0.");
        return false;
      }
    }

    if ((isTakeProfitEnabled || isStopLossEnabled) && !hasCurrentMarketPrice) {
      toast.error("Current market price is unavailable. Please try again.");
      return false;
    }

    if (isTakeProfitEnabled) {
      if (!["market", "limit"].includes(formData.take_profit_order_type)) {
        toast.error("Take profit order type must be Market or Limit.");
        return false;
      }

      if (
        isBlank(formData.take_profit_price) ||
        !isPositiveNumber(formData.take_profit_price)
      ) {
        toast.error("Take profit price must be greater than 0.");
        return false;
      }

      if (!["bid", "ask", "last"].includes(formData.take_profit_type)) {
        toast.error("Take profit price source must be Bid, Ask, or Last.");
        return false;
      }

      const takeProfitPrice = toNumber(formData.take_profit_price);
      if (
        formData.position_type === "buy" &&
        takeProfitPrice <= currentMarketPrice
      ) {
        toast.error(
          "For Buy positions, take profit must be above the current price.",
        );
        return false;
      }

      if (
        formData.position_type === "sell" &&
        takeProfitPrice >= currentMarketPrice
      ) {
        toast.error(
          "For Sell positions, take profit must be below the current price.",
        );
        return false;
      }

      if (isTakeProfitTrailingEnabled) {
        if (
          isBlank(formData.take_profit_percentage) ||
          !isPercentageRange(formData.take_profit_percentage)
        ) {
          toast.error(
            "Take profit trailing percentage must be between 0.01 and 100.",
          );
          return false;
        }
      }
    }

    if (isStopLossEnabled) {
      if (!["market", "limit"].includes(formData.stop_loss_order_type)) {
        toast.error("Stop loss order type must be Market or Limit.");
        return false;
      }

      if (
        isBlank(formData.stop_loss_price) ||
        !isPositiveNumber(formData.stop_loss_price)
      ) {
        toast.error("Stop loss price must be greater than 0.");
        return false;
      }

      if (!["bid", "ask", "last"].includes(formData.stop_loss_price_type)) {
        toast.error("Stop loss price source must be Bid, Ask, or Last.");
        return false;
      }

      const stopLossPrice = toNumber(formData.stop_loss_price);
      if (
        formData.position_type === "buy" &&
        stopLossPrice >= currentMarketPrice
      ) {
        toast.error(
          "For Buy positions, stop loss must be below the current price.",
        );
        return false;
      }

      if (
        formData.position_type === "sell" &&
        stopLossPrice <= currentMarketPrice
      ) {
        toast.error(
          "For Sell positions, stop loss must be above the current price.",
        );
        return false;
      }

      if (isStopLossTimeoutEnabled) {
        if (isBlank(formData.stop_loss_timeout_seconds)) {
          toast.error("Stop loss timeout is required.");
          return false;
        }

        if (!isIntegerAtLeastOne(formData.stop_loss_timeout_seconds)) {
          toast.error(
            "Stop loss timeout must be an integer greater than or equal to 1.",
          );
          return false;
        }
      }

      if (isStopLossTrailingEnabled) {
        if (
          isBlank(formData.stoploss_percentage) ||
          !isPercentageRange(formData.stoploss_percentage)
        ) {
          toast.error(
            "Stop loss trailing percentage must be between 0.01 and 100.",
          );
          return false;
        }
      }
    }

    if (!isBlank(formData.note) && String(formData.note).length > 300) {
      toast.error("Note must be 300 characters or fewer.");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setSubmitLoading(true);
    try {
      const isEnabled = (value) => value === true || value === "true";

      const payload = {
        pair: formData.pair,
        position_type: formData.position_type,
        position_order_type: formData.position_order_type,
        position_units: Number(formData.position_units),
      };

      if (formData.position_order_type === "limit") {
        payload.position_price = Number(formData.position_price);
      }

      if (String(formData.note || "").trim()) {
        payload.note = String(formData.note).trim();
      }

      payload.leverage_enabled = formData.leverage_enabled;
      if (isEnabled(formData.leverage_enabled)) {
        payload.leverage_type = formData.leverage_type;
        payload.leverage_value = Number(formData.leverage_value);
      }

      payload.conditional_enabled = formData.conditional_enabled;
      if (isEnabled(formData.conditional_enabled)) {
        payload.conditional_order_type = formData.conditional_order_type;
        payload.conditional_price = Number(formData.conditional_price);
      }

      payload.take_profit_enabled = formData.take_profit_enabled;
      if (isEnabled(formData.take_profit_enabled)) {
        payload.take_profit_order_type = formData.take_profit_order_type;
        payload.take_profit_price = Number(formData.take_profit_price);
        payload.take_profit_type = formData.take_profit_type;
        payload.take_profit_trailing = formData.take_profit_trailing;
        payload.take_profit_volume = 100;

        if (isEnabled(formData.take_profit_trailing)) {
          payload.take_profit_percentage = Number(
            formData.take_profit_percentage,
          );
        }
      }

      payload.stop_loss_enabled = formData.stop_loss_enabled;
      if (isEnabled(formData.stop_loss_enabled)) {
        payload.stop_loss_order_type = formData.stop_loss_order_type;
        payload.stop_loss_price = Number(formData.stop_loss_price);
        payload.stop_loss_price_type = formData.stop_loss_price_type;
        payload.stop_loss_breakeven = formData.stop_loss_breakeven;

        payload.stop_loss_timeout_enabled = formData.stop_loss_timeout_enabled;
        if (isEnabled(formData.stop_loss_timeout_enabled)) {
          payload.stop_loss_timeout_seconds = Number(
            formData.stop_loss_timeout_seconds,
          );
        }

        payload.stop_loss_trailing = formData.stop_loss_trailing;
        if (isEnabled(formData.stop_loss_trailing)) {
          payload.stoploss_percentage = Number(formData.stoploss_percentage);
        }
      }

      const url = `${consts.BackendUrl}/bots/create-smart-trade`;
      const response = await path.postCall({ url, payload: payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "Smart Trade created successfully");
        setOpenTrade(false);
        resetForm();
        await getSmartTrades();
      } else {
        toast.error(result?.message || "Failed to create smart trade.");
      }
    } catch (err) {
      toast.error("Failed to create smart trade.");
    } finally {
      setSubmitLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({ ...initialForm });
    setEditIndex(null);
  };

  const handleOpenTrade = () => {
    resetForm();
    setOpenTrade(true);
  };

  const handleCloseTrade = () => {
    setOpenTrade(false);
    resetForm();
  };

  const getSmartTrades = async ({
    status = null,
    pageValue = paginationRef.current.page,
    rowsPerPageValue = paginationRef.current.rowsPerPage,
  } = {}) => {
    try {
      setTradeLoading(true);
      const url = `${consts.BackendUrl}/bots/get-smart-trade?page=${pageValue + 1}&limit=${rowsPerPageValue}`;
      const payload = {
        limit: rowsPerPageValue,
        offset: pageValue * rowsPerPageValue,
      };

      if (status) {
        payload.status = status;
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        const trades = result?.result?.docs || [];
        const totalDocs = Number(result?.result?.totalDocs || 0);

        if (totalDocs > 0 && trades.length === 0 && pageValue > 0) {
          setPage(Math.max(0, Math.ceil(totalDocs / rowsPerPageValue) - 1));
          return;
        }

        setSmartTrades(trades);
        setSmartTradeTotal(totalDocs);
      } else {
        setSmartTrades([]);
        setSmartTradeTotal(0);
      }
    } catch (err) {
      setSmartTrades([]);
      setSmartTradeTotal(0);
    } finally {
      setTradeLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    getPairs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getSmartTrades();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  useEffect(() => {
    const socket = io(consts?.socketUrl, {
      path: "/socket",
    });

    socket.on("connect", () => {
      socket.emit("join", {
        room: localStorage.getItem("use"),
      });

      console.log("socket connected");
    });

    socket.on("smart_trade_update", (data) => {
      try {
        setSmartTrades((prev) =>
          prev.map((trade) => (trade._id === data._id ? data : trade)),
        );
      } catch (e) {
        console.log(e);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "---";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  const handleOpenFundsModal = async (tradeId) => {
    setSelectedTradeId(tradeId);
    setOpenFundsModal(true);
    await getSmartTradeReduceInfo(tradeId);
  };

  const handleCloseFundsModal = () => {
    setOpenFundsModal(false);
    setSelectedTradeId(null);
    setReduceInfo(null);
    setFundsFormData({ ...INITIAL_FUNDS_FORM_DATA });
  };

  const getSmartTradeReduceInfo = async (tradeId) => {
    try {
      setFundsLoading(true);
      const url = `${consts.BackendUrl}/bots/smart-trade-reduce-info`;
      const payload = { id: tradeId };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        setReduceInfo(result.result);
      } else {
      }
    } catch (err) {
    } finally {
      setFundsLoading(false);
    }
  };

  const handleManageSmartTradeFunds = async () => {
    try {
      const units = Number(fundsFormData.units);
      const price = Number(fundsFormData.price);

      if (!selectedTradeId || !fundsFormData.order_type) {
        toast.error("Please fill in all required fields.");
        return;
      }

      if (
        fundsFormData.units === undefined ||
        fundsFormData.units === null ||
        String(fundsFormData.units).trim() === "" ||
        Number.isNaN(units) ||
        units <= 0
      ) {
        toast.error("Units must be greater than 0.");
        return;
      }

      if (
        fundsFormData.order_type === "limit" &&
        (fundsFormData.price === undefined ||
          fundsFormData.price === null ||
          String(fundsFormData.price).trim() === "" ||
          Number.isNaN(price) ||
          price <= 0)
      ) {
        toast.error("Limit order price must be greater than 0.");
        return;
      }

      setFundsLoading(true);
      const url = `${consts.BackendUrl}/bots/smart-trade-funds`;
      const payload = {
        id: selectedTradeId,
        type: fundsFormData.type,
        order_type: fundsFormData.order_type,
        units: fundsFormData.units,
      };

      if (fundsFormData.price) {
        payload.price = fundsFormData.price;
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        handleCloseFundsModal();
        await getSmartTrades();
      } else {
      }
    } catch (err) {
    } finally {
      setFundsLoading(false);
    }
  };

  const openConfirmModal = (actionType, tradeId, message) => {
    setConfirmAction({
      action: actionType,
      tradeId,
      message,
    });
    setShowConfirmModal(true);
  };

  const closeConfirmModal = () => {
    setShowConfirmModal(false);
    setConfirmAction({
      action: null,
      tradeId: null,
      message: null,
    });
  };

  const executeConfirmedAction = async () => {
    try {
      setActionLoading(true);
      const { action, tradeId } = confirmAction;
      let url;
      let payload = { smart_trade_id: tradeId };

      if (action === "cancel") {
        url = `${consts.BackendUrl}/bots/cancel-smart-trade`;
      } else if (action === "close") {
        url = `${consts.BackendUrl}/bots/close-smart-trade-at-market`;
      } else if (action === "force-start") {
        url = `${consts.BackendUrl}/bots/force-start-smart-trade`;
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        toast.success(result?.message || "Action executed successfully");
        closeConfirmModal();
        await getSmartTrades();
      } else {
        toast.error(result?.message || "Failed to execute the action.");
      }
    } catch (err) {
      toast.error("Something went wrong while executing the action.");
    } finally {
      setActionLoading(false);
    }
  };

  const handleOpenTradesModal = async (tradeId) => {
    setSelectedSmartTradeId(tradeId);
    setOpenTradesModal(true);
    await getSmartTradeTradesData(tradeId);
  };

  const handleCloseTradesModal = () => {
    setOpenTradesModal(false);
    setSelectedSmartTradeId(null);
    setSmartTradeTrades([]);
  };

  const getSmartTradeTradesData = async (tradeId) => {
    try {
      setTradesLoading(true);
      const url = `${consts.BackendUrl}/bots/get-smart-trade-trades`;
      const payload = { smart_trade_id: tradeId };
      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        const trades = Array.isArray(result.result) ? result.result : [];
        setSmartTradeTrades(trades);
      } else {
        setSmartTradeTrades([]);
      }
    } finally {
      setTradesLoading(false);
    }
  };

  const openTradeConfirmModal = (
    actionType,
    smartTradeId,
    tradeId,
    message,
  ) => {
    setConfirmTradeAction({
      action: actionType,
      smartTradeId,
      tradeId,
      message,
    });
    setShowTradeConfirmModal(true);
  };

  const closeTradeConfirmModal = () => {
    setShowTradeConfirmModal(false);
    setConfirmTradeAction({
      action: null,
      smartTradeId: null,
      tradeId: null,
      message: null,
    });
  };

  const executeTradeAction = async () => {
    try {
      setTradeActionLoading(true);
      const { action, smartTradeId, tradeId } = confirmTradeAction;
      let url;
      let payload = { smart_trade_id: smartTradeId, trade_id: tradeId };

      if (action === "close") {
        url = `${consts.BackendUrl}/bots/close-smart-trade-trade-at-market`;
      } else if (action === "cancel") {
        url = `${consts.BackendUrl}/bots/cancel-smart-trade-trade`;
      }

      const response = await path.postCall({ url, payload });
      const result = await response.json();

      if (result?.success) {
        const actionMessages = {
          close: "Trade closed at market price successfully",
          cancel: "Trade cancelled successfully",
        };
        if (action !== "cancel") {
          toast.success(result?.message || actionMessages[action]);
        }
        closeTradeConfirmModal();
        await getSmartTradeTradesData(smartTradeId);
      } else {
        toast.error(result?.message || "Failed to execute the action.");
      }
    } finally {
      setTradeActionLoading(false);
    }
  };

  return (
    <div className="market-full page_align" style={{ minHeight: "100vh" }}>
      <Header />
      <Toaster />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="bot_dash contain-width ">
            <div className="display-2">
              <h3 className="">Smart Trade</h3>
              <div className="bot_comman_btn">
                <Button onClick={handleOpenTrade}>Create Trade</Button>
              </div>
            </div>
          </div>
          <div className="mt-20">
            <div className="custom_table box_bdr mt-20">
              <div className="h_flx">
                <h3>Smart Trade</h3>
              </div>

              <TableContainer sx={{ marginBottom: "10px", width: "100%" }}>
                <Table sx={{ minWidth: 650 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Created At</TableCell>
                      <TableCell>Trade ID</TableCell>
                      <TableCell>Pair</TableCell>
                      <TableCell>Position Type</TableCell>
                      <TableCell>Order Type</TableCell>
                      <TableCell>Units</TableCell>
                      <TableCell>Price</TableCell>
                      <TableCell>Total</TableCell>
                      <TableCell>Status</TableCell>
                      {/* <TableCell>Profit (%)</TableCell> */}
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {tradeLoading ? (
                      <TableRow>
                        <TableCell colSpan={11}>
                          <div className="inline-loader">
                            <Loader />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : smartTrades?.length > 0 ? (
                      smartTrades.map((row, i) => {
                        return (
                          <TableRow key={i} className="tr_row">
                            <TableCell>{formatDate(row?.createdAt)}</TableCell>
                            <TableCell>{row.smart_trade_id || "-"}</TableCell>

                            <TableCell>{row.pair || "-"}</TableCell>
                            <TableCell
                              style={{
                                color:
                                  row.position?.type === "long" ||
                                  row.position?.type === "buy"
                                    ? "#00C853"
                                    : "#FF5252",
                              }}
                            >
                              {row.position?.type
                                ? row.position?.type?.toUpperCase()
                                : "-"}
                            </TableCell>
                            <TableCell>
                              {row.position?.order_type
                                ? row.position?.order_type?.toUpperCase()
                                : "-"}
                            </TableCell>
                            <TableCell>
                              {row?.position?.units?.value || "-"}
                              {/* {getValue(row.position?.units)} */}
                            </TableCell>
                            <TableCell>
                              {row?.position?.price?.value || "-"}
                              {/* {getValue(row.position?.price)} */}
                            </TableCell>
                            <TableCell>
                              {row?.position?.total?.value || "-"}
                              {/* {getValue(row.position?.total)} */}
                            </TableCell>
                            <TableCell>
                              <span
                                style={{
                                  color:
                                    row.status === "Completed"
                                      ? "#00C853"
                                      : row.status === "Failed"
                                        ? "#FF5252"
                                        : "#f8d821",
                                }}
                              >
                                {row.status}
                              </span>
                            </TableCell>
                            {/* <TableCell
                              style={{
                                color:
                                  Number(row.profit?.percent) >= 0
                                    ? "#00C853"
                                    : "#FF5252",
                              }}
                            >
                              {row.profit?.percent != null
                                ? `${Number(row.profit?.percent).toFixed(2)}%`
                                : "-"}
                            </TableCell> */}
                            <TableCell>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "4px",
                                  flexWrap: "wrap",
                                }}
                              >
                                <Button
                                  size="small"
                                  variant="contained"
                                  onClick={() =>
                                    handleOpenTradesModal(row.smart_trade_id)
                                  }
                                  sx={{
                                    fontSize: "0.7rem",
                                    padding: "4px 8px",
                                  }}
                                >
                                  View
                                </Button>
                                {/* {!isFailed && (
                                    <>
                                      {row?.data?.force_start_available && (
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="info"
                                          onClick={() => {
                                            openConfirmModal(
                                              "force-start",
                                              row.smart_trade_id,
                                              "Force start this trade at market price?",
                                            );
                                          }}
                                          sx={{
                                            fontSize: "0.7rem",
                                            padding: "4px 8px",
                                          }}
                                        >
                                          Force Start
                                        </Button>
                                      )}
                                      {row?.data?.panic_sell_available && (
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="warning"
                                          onClick={() => {
                                            openConfirmModal(
                                              "close",
                                              row.smart_trade_id,
                                              "Close this trade at market price?",
                                            );
                                          }}
                                          sx={{
                                            fontSize: "0.7rem",
                                            padding: "4px 8px",
                                          }}
                                        >
                                          Close
                                        </Button>
                                      )}
                                      {row?.data?.cancel_available && (
                                        <Button
                                          size="small"
                                          variant="contained"
                                          color="error"
                                          onClick={() => {
                                            openConfirmModal(
                                              "cancel",
                                              row.smart_trade_id,
                                              "Cancel this trade? This action cannot be undone.",
                                            );
                                          }}
                                          sx={{
                                            fontSize: "0.7rem",
                                            padding: "4px 8px",
                                          }}
                                        >
                                          Cancel
                                        </Button>
                                      )}
                                    </>
                                  )} */}
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell colSpan={11} align="center">
                          No Trades Found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  component="div"
                  count={smartTradeTotal || smartTrades.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPageOptions={[10]}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </div>
          </div>
        </Grid>
      </Grid>

      <Modal
        open={openTrade}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">
              {editIndex !== null ? "Edit Smart Trade" : "Create Smart Trade"}
            </div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={handleCloseTrade}
            />
          </div>

          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            mt={2}
            className=""
            style={{ maxHeight: "500px", overflow: "auto" }}
          >
            <FormLabel
              size="small"
              sx={{ color: "var(--clr-font)", fontSize: "12px", mt: 0 }}
            >
              Current Price : {currencyRates?.last ? currencyRates.last : 0}{" "}
              USDT
            </FormLabel>
            {pairs && pairs.length && (
              <FormControl fullWidth required>
                <InputLabel id="pair-label">Pair</InputLabel>
                <Select
                  className="bot-select"
                  fullWidth
                  name="pair"
                  value={formData.pair}
                  onChange={handleChange}
                  labelId="pair-label"
                  id="pair"
                  label="Pair"
                  disabled={pairsLoading || editIndex !== null}
                  required
                >
                  <MenuItem value="">Select Pair</MenuItem>
                  <TextField
                    size="small"
                    placeholder="Search pairs"
                    className="bot-input"
                    fullWidth
                    value={pairSearch}
                    onChange={(e) => setPairSearch(e.target.value)}
                    onKeyDown={(e) => e.stopPropagation()}
                    sx={{ width: "90%", margin: "10px auto", display: "block" }}
                  />
                  {filteredPairs.map((p, idx) => {
                    const label = getPairLabel(p);
                    const value = getPairValue(p);
                    return (
                      <MenuItem key={idx} value={value}>
                        {label}
                      </MenuItem>
                    );
                  })}
                  {filteredPairs.length === 0 && (
                    <MenuItem disabled>No pairs found</MenuItem>
                  )}
                </Select>
              </FormControl>
            )}
            <TextField
              label="Position Units (Quantity) (required)"
              name="position_units"
              type="text"
              fullWidth
              className="bot-input"
              value={formData.position_units}
              onChange={handleChange}
              required
            />
            <FormControl fullWidth>
              <InputLabel>Position Order Type</InputLabel>
              <Select
                className="bot-select"
                name="position_order_type"
                value={formData.position_order_type}
                onChange={handleChange}
                label="Position Order Type"
              >
                <MenuItem value="market">Market</MenuItem>
                <MenuItem value="limit">Limit</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>Position Type</InputLabel>
              <Select
                className="bot-select"
                name="position_type"
                value={formData.position_type}
                onChange={handleChange}
                label="Position Type"
              >
                <MenuItem value="buy">Buy</MenuItem>
                <MenuItem value="sell">Sell</MenuItem>
              </Select>
            </FormControl>
            {formData.position_order_type === "limit" && (
              <TextField
                label="Position Price (required)"
                name="position_price"
                type="text"
                fullWidth
                className="bot-input"
                value={formData.position_price}
                onChange={handleChange}
                required={
                  formData.position_order_type === "limit" ||
                  formData.position_order_type === "market"
                }
              />
            )}
            {/* <FormControl fullWidth>
              <InputLabel>Leverage (optional)</InputLabel>
              <Select
                className="bot-select"
                name="leverage_enabled"
                value={formData.leverage_enabled}
                onChange={handleChange}
                label="Leverage (optional)"
              >
                <MenuItem value="false">Disable Leverage</MenuItem>
                <MenuItem value="true">Enable Leverage</MenuItem>
              </Select>
            </FormControl> */}
            {formData.leverage_enabled === "true" && (
              <>
                <FormControl fullWidth>
                  <InputLabel>Leverage Type</InputLabel>
                  <Select
                    className="bot-select"
                    name="leverage_type"
                    value={formData.leverage_type}
                    onChange={handleChange}
                    label="Leverage Type"
                  >
                    <MenuItem value="cross">Cross</MenuItem>
                    <MenuItem value="isolated">Isolated</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  label="Leverage Value"
                  name="leverage_value"
                  type="text"
                  fullWidth
                  className="bot-input"
                  value={formData.leverage_value}
                  onChange={handleChange}
                />
              </>
            )}
            <FormControl fullWidth>
              <InputLabel>Conditional Order (optional)</InputLabel>
              <Select
                className="bot-select"
                name="conditional_enabled"
                value={formData.conditional_enabled}
                onChange={handleChange}
                label="Conditional Order (optional)"
              >
                <MenuItem value="false">Disabled</MenuItem>
                <MenuItem value="true">Enabled</MenuItem>
              </Select>
            </FormControl>
            {formData.conditional_enabled === "true" && (
              <>
                <FormControl fullWidth>
                  <InputLabel>Conditional Order Type</InputLabel>
                  <Select
                    className="bot-select"
                    name="conditional_order_type"
                    value={formData.conditional_order_type}
                    onChange={handleChange}
                    label="Conditional Order Type"
                  >
                    <MenuItem value="market">Market</MenuItem>
                    <MenuItem value="limit">Limit</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  label="Conditional Price"
                  name="conditional_price"
                  type="text"
                  fullWidth
                  className="bot-input"
                  value={formData.conditional_price}
                  onChange={handleChange}
                />
              </>
            )}
            <FormControl fullWidth>
              <InputLabel>Take Profit (optional)</InputLabel>
              <Select
                className="bot-select"
                name="take_profit_enabled"
                value={formData.take_profit_enabled}
                onChange={handleChange}
                label="Take Profit (optional)"
              >
                <MenuItem value="false">Disabled</MenuItem>
                <MenuItem value="true">Enabled</MenuItem>
              </Select>
            </FormControl>
            {formData.take_profit_enabled === "true" && (
              <>
                <FormControl fullWidth>
                  <InputLabel>Take Profit Order Type</InputLabel>
                  <Select
                    className="bot-select"
                    name="take_profit_order_type"
                    value={formData.take_profit_order_type}
                    onChange={handleChange}
                    label="Take Profit Order Type"
                  >
                    <MenuItem value="market">Market</MenuItem>
                    <MenuItem value="limit">Limit</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  label="Take Profit Price"
                  name="take_profit_price"
                  type="text"
                  fullWidth
                  className="bot-input"
                  value={formData.take_profit_price}
                  onChange={handleChange}
                />
                <FormControl fullWidth>
                  <InputLabel>Take Profit Type</InputLabel>
                  <Select
                    className="bot-select"
                    name="take_profit_type"
                    value={formData.take_profit_type}
                    onChange={handleChange}
                    label="Take Profit Type"
                  >
                    <MenuItem value="ask">Ask</MenuItem>
                    <MenuItem value="bid">Bid</MenuItem>
                    <MenuItem value="last">Last</MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel>Take Profit Trailing % (Optional)</InputLabel>
                  <Select
                    className="bot-select"
                    name="take_profit_trailing"
                    value={formData.take_profit_trailing}
                    onChange={handleChange}
                    label="Take Profit Trailing % (Optional)"
                  >
                    <MenuItem value="false">Disabled</MenuItem>
                    <MenuItem value="true">Enabled</MenuItem>
                  </Select>
                </FormControl>
                {formData.take_profit_trailing === "true" && (
                  <TextField
                    label="Take Profit Trailing Distance"
                    name="take_profit_percentage"
                    type="text"
                    fullWidth
                    className="bot-input"
                    value={formData.take_profit_percentage}
                    onChange={handleChange}
                  />
                )}
              </>
            )}
            <FormControl fullWidth>
              <InputLabel>Stop Loss (optional)</InputLabel>
              <Select
                className="bot-select"
                name="stop_loss_enabled"
                value={formData.stop_loss_enabled}
                onChange={handleChange}
                label="Stop Loss (optional)"
              >
                <MenuItem value="false">Disabled</MenuItem>
                <MenuItem value="true">Enabled</MenuItem>
              </Select>
            </FormControl>

            {formData.stop_loss_enabled === "true" && (
              <>
                <FormControl fullWidth>
                  <InputLabel>Stop Loss Order Type</InputLabel>
                  <Select
                    className="bot-select"
                    name="stop_loss_order_type"
                    value={formData.stop_loss_order_type}
                    onChange={handleChange}
                    label="Stop Loss Order Type"
                  >
                    <MenuItem value="market">Market</MenuItem>
                    <MenuItem value="limit">Limit</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  label="Stop Loss Price"
                  name="stop_loss_price"
                  type="text"
                  fullWidth
                  className="bot-input"
                  value={formData.stop_loss_price}
                  onChange={handleChange}
                />

                <FormControl fullWidth>
                  <InputLabel>Stop Loss Price Type</InputLabel>
                  <Select
                    className="bot-select"
                    name="stop_loss_price_type"
                    value={formData.stop_loss_price_type}
                    onChange={handleChange}
                    label="Stop Loss Price Type"
                  >
                    <MenuItem value="bid">Bid</MenuItem>
                    <MenuItem value="ask">Ask</MenuItem>
                    <MenuItem value="last">Last</MenuItem>
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <InputLabel>Stop Loss Timeout</InputLabel>
                  <Select
                    className="bot-select"
                    name="stop_loss_timeout_enabled"
                    value={formData.stop_loss_timeout_enabled}
                    onChange={handleChange}
                    label="Stop Loss Timeout"
                  >
                    <MenuItem value="false">Disabled</MenuItem>
                    <MenuItem value="true">Enabled</MenuItem>
                  </Select>
                </FormControl>

                {formData.stop_loss_timeout_enabled === "true" && (
                  <TextField
                    label="Timeout Seconds"
                    name="stop_loss_timeout_seconds"
                    type="text"
                    fullWidth
                    className="bot-input"
                    value={formData.stop_loss_timeout_seconds}
                    onChange={handleChange}
                  />
                )}

                <FormControl fullWidth>
                  <InputLabel>Trailing Stop Loss</InputLabel>
                  <Select
                    className="bot-select"
                    name="stop_loss_trailing"
                    value={formData.stop_loss_trailing}
                    onChange={handleChange}
                    label="Trailing Stop Loss"
                  >
                    <MenuItem value="false">Disabled</MenuItem>
                    <MenuItem value="true">Enabled</MenuItem>
                  </Select>
                </FormControl>

                {formData.stop_loss_trailing === "true" && (
                  <TextField
                    label="Trailing Percentage"
                    name="stoploss_percentage"
                    type="text"
                    fullWidth
                    className="bot-input"
                    value={formData.stoploss_percentage}
                    onChange={handleChange}
                  />
                )}

                <FormControl fullWidth>
                  <InputLabel>Move Stop to Breakeven</InputLabel>
                  <Select
                    className="bot-select"
                    name="stop_loss_breakeven"
                    value={formData.stop_loss_breakeven}
                    onChange={handleChange}
                    label="Move Stop to Breakeven"
                  >
                    <MenuItem value="false">Disabled</MenuItem>
                    <MenuItem value="true">Enabled</MenuItem>
                  </Select>
                </FormControl>
              </>
            )}
            <TextField
              label="Note (optional)"
              name="note"
              fullWidth
              multiline
              rows={2}
              className="bot-input"
              value={formData.note}
              onChange={handleChange}
            />
          </Box>

          <div className="bot_comman_btn display-3 mt-20">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={submitLoading}
            >
              {submitLoading ? "Submitting..." : "Submit"}
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openFundsModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="display-2 p-20">
            <div className="coins">Manage Smart Trade Funds</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={handleCloseFundsModal}
            />
          </div>

          <Box
            display="flex"
            flexDirection="column"
            gap={2}
            mt={2}
            style={{ maxHeight: "400px", overflow: "auto" }}
          >
            {fundsLoading ? (
              <div className="inline-loader">
                <Loader />
              </div>
            ) : (
              <>
                <FormControl fullWidth>
                  <InputLabel id="funds-type-label">Type</InputLabel>
                  <Select
                    className="bot-select"
                    labelId="funds-type-label"
                    id="funds-type"
                    value={fundsFormData.type}
                    label="Type"
                    onChange={(e) =>
                      setFundsFormData({
                        ...fundsFormData,
                        type: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="add">Add Funds</MenuItem>
                    <MenuItem value="reduce">Reduce Funds</MenuItem>
                  </Select>
                </FormControl>

                {fundsFormData.type === "reduce" && reduceInfo && (
                  <Box
                    sx={{
                      backgroundColor: "rgba(86, 111, 255, 0.1)",
                      padding: "12px",
                      borderRadius: "8px",
                    }}
                  >
                    <p style={{ margin: "0 0 8px 0", fontSize: "0.9rem" }}>
                      <strong>Available to Reduce:</strong>{" "}
                      {reduceInfo?.available}
                    </p>
                    {reduceInfo?.required && (
                      <p style={{ margin: "0", fontSize: "0.9rem" }}>
                        <strong>Required to Keep:</strong>{" "}
                        {reduceInfo?.required}
                      </p>
                    )}
                  </Box>
                )}

                <FormControl fullWidth>
                  <InputLabel id="order-type-label">Order Type</InputLabel>
                  <Select
                    className="bot-select"
                    labelId="order-type-label"
                    id="order-type"
                    value={fundsFormData.order_type}
                    label="Order Type"
                    onChange={(e) =>
                      setFundsFormData({
                        ...fundsFormData,
                        order_type: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="market">Market</MenuItem>
                    <MenuItem value="limit">Limit</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  label="Units"
                  type="text"
                  value={fundsFormData.units}
                  onChange={(e) =>
                    setFundsFormData({
                      ...fundsFormData,
                      units: e.target.value,
                    })
                  }
                />

                {fundsFormData.order_type === "limit" && (
                  <TextField
                    fullWidth
                    label="Price"
                    type="text"
                    value={fundsFormData.price}
                    onChange={(e) =>
                      setFundsFormData({
                        ...fundsFormData,
                        price: e.target.value,
                      })
                    }
                  />
                )}
              </>
            )}
          </Box>

          <div className="modal-footer mt-20">
            <Button
              variant="contained"
              onClick={handleCloseFundsModal}
              disabled={fundsLoading}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleManageSmartTradeFunds}
              disabled={fundsLoading}
            >
              {fundsLoading
                ? "Processing..."
                : `${fundsFormData.type === "add" ? "Add" : "Reduce"} Funds`}
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={showConfirmModal}
        aria-labelledby="confirm-modal-title"
        aria-describedby="confirm-modal-description"
      >
        <Box sx={style}>
          <div className="p-20">
            {confirmAction.message || "Are you sure you want to proceed?"}
          </div>

          <div className="display-2">
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={closeConfirmModal}
                disabled={actionLoading}
              >
                No
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color={
                  confirmAction.action === "cancel"
                    ? "error"
                    : confirmAction.action === "close"
                      ? "warning"
                      : "info"
                }
                onClick={executeConfirmedAction}
                disabled={actionLoading}
              >
                {actionLoading ? "Processing..." : "Yes"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openTradesModal}
        aria-labelledby="trades-modal-title"
        aria-describedby="trades-modal-description"
      >
        <Box sx={{ ...style, width: 900, maxHeight: "90vh", overflow: "auto" }}>
          <div className="display-2 p-20">
            <div className="coins">Smart Trade Trades</div>
            <HighlightOffIcon
              className="cursor"
              sx={{ fill: "var(--clr-font)", fontSize: "25px !important" }}
              onClick={handleCloseTradesModal}
            />
          </div>

          <Box sx={{ padding: "20px" }}>
            {tradesLoading ? (
              <div className="inline-loader">
                <Loader />
              </div>
            ) : smartTradeTrades.length > 0 ? (
              <TableContainer
                sx={{
                  maxHeight: "320px",
                  overflow: "auto",
                  borderRadius: "10px",
                  border: "1px solid rgba(255,255,255,0.18)",
                  backgroundColor: "rgba(8,12,18,0.92)",
                  boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.08)",
                  color: "#FFFFFF",
                }}
              >
                <Table
                  size="small"
                  stickyHeader
                  sx={{
                    "& .MuiTableCell-root": {
                      color: "#FFFFFF",
                      borderColor: "rgba(255,255,255,0.12)",
                    },
                    "& .MuiTableHead-root .MuiTableCell-root": {
                      backgroundColor: "#10151C",
                      fontWeight: 700,
                    },
                    "& .MuiTableBody-root .MuiTableRow-root": {
                      backgroundColor: "rgba(10,14,20,0.88)",
                    },
                    "& .MuiTableBody-root .MuiTableRow-root:hover": {
                      backgroundColor: "rgba(18,24,32,0.95)",
                    },
                  }}
                >
                  <TableHead>
                    <TableRow sx={{}}>
                      <TableCell>Trade ID</TableCell>
                      <TableCell>Pair</TableCell>
                      <TableCell>Side</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Initial Amount</TableCell>
                      <TableCell>Initial Total</TableCell>
                      <TableCell>Realised Amount</TableCell>
                      <TableCell>Realised Total</TableCell>
                      <TableCell>Realised %</TableCell>
                      <TableCell>Created At</TableCell>
                      <TableCell>Updated At</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {smartTradeTrades.map((trade, i) => (
                      <TableRow key={i} className="tr_row">
                        <TableCell>{trade?.id || "-"}</TableCell>
                        <TableCell>{trade?.pair || "-"}</TableCell>
                        <TableCell
                          style={{
                            color:
                              trade?.order_side === "buy"
                                ? "#00C853"
                                : "#FF5252",
                          }}
                        >
                          {trade?.order_side?.toUpperCase()}
                        </TableCell>
                        <TableCell>
                          {trade?.order_type?.toUpperCase() || "-"}
                        </TableCell>
                        <TableCell
                          style={{
                            color:
                              trade?.status === "finished"
                                ? "#00C853"
                                : trade?.status === "cancelled"
                                  ? "#FF5252"
                                  : "#FFA500",
                          }}
                        >
                          {trade?.status === "failed"
                            ? "Failed"
                            : trade.status === "to_process"
                              ? "Processing"
                              : trade?.status?.charAt(0)?.toUpperCase() +
                                trade?.status?.slice(1)}
                        </TableCell>
                        <TableCell>{trade?.initial_amount || "-"}</TableCell>
                        <TableCell>{trade?.initial_total || "-"}</TableCell>
                        <TableCell>{trade?.realised_amount || "-"}</TableCell>
                        <TableCell>{trade?.realised_total || "-"}</TableCell>
                        <TableCell
                          style={{
                            color:
                              parseFloat(trade?.realised_percentage) > 0
                                ? "#00C853"
                                : "#FF5252",
                          }}
                        >
                          {trade?.realised_percentage || "-"}
                        </TableCell>
                        <TableCell>{formatDate(trade?.created_at)}</TableCell>
                        <TableCell>{formatDate(trade?.updated_at)}</TableCell>
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              gap: "4px",
                              flexWrap: "wrap",
                            }}
                          >
                            {trade?.force_processable && (
                              <Button
                                size="small"
                                variant="contained"
                                color="warning"
                                onClick={() =>
                                  openTradeConfirmModal(
                                    "close",
                                    selectedSmartTradeId,
                                    trade?.id,
                                    "Close this trade at market price?",
                                  )
                                }
                                sx={{
                                  fontSize: "0.65rem",
                                  padding: "3px 6px",
                                }}
                              >
                                Close at Market
                              </Button>
                            )}
                            {trade?.cancellable && (
                              <Button
                                size="small"
                                variant="contained"
                                color="error"
                                onClick={() =>
                                  openTradeConfirmModal(
                                    "cancel",
                                    selectedSmartTradeId,
                                    trade?.id,
                                    "Cancel this trade?",
                                  )
                                }
                                sx={{
                                  fontSize: "0.65rem",
                                  padding: "3px 6px",
                                }}
                              >
                                Cancel
                              </Button>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <p style={{ textAlign: "center", padding: "20px" }}>
                No trades found for this Smart Trade
              </p>
            )}
          </Box>

          <div className="modal-footer mt-20">
            <Button
              variant="contained"
              onClick={handleCloseTradesModal}
              disabled={tradesLoading}
            >
              Close
            </Button>
          </div>
        </Box>
      </Modal>

      <Modal
        open={showTradeConfirmModal}
        aria-labelledby="trade-confirm-modal-title"
        aria-describedby="trade-confirm-modal-description"
      >
        <Box sx={style}>
          <div className="p-20">
            {confirmTradeAction.message || "Are you sure you want to proceed?"}
          </div>

          <div className="display-2">
            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                onClick={closeTradeConfirmModal}
                disabled={tradeActionLoading}
              >
                No
              </Button>
            </div>

            <div className="bot_comman_btn display-3 mt-20">
              <Button
                variant="contained"
                color={
                  confirmTradeAction.action === "cancel" ? "error" : "warning"
                }
                onClick={executeTradeAction}
                disabled={tradeActionLoading}
              >
                {tradeActionLoading ? "Processing..." : "Yes"}
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default SmartTrade;
